import {
  ButtonBase,
  ButtonBaseProps,
  SvgIconProps,
  SxProps,
  Typography,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"
import { SearchIcon } from "../../icons"

interface ISearchToggleButtonProps extends ButtonBaseProps {
  placeholder?: string
  onClick: () => void
  icon?: (props: SvgIconProps) => React.ReactNode
  sx?: SxProps
}

export const SearchToggleButton = ({
  placeholder = "Search",
  onClick,
  icon: Icon = SearchIcon,
  sx = {},
  ...props
}: ISearchToggleButtonProps) => {
  const theme = useTheme()

  const styleOverrides =
    theme.components[`VuiSearchToggleButton`]?.styleOverrides || {}

  const { root, searchIcon, label } = styleOverrides
  return (
    <ButtonBase
      className="VuiSearchToggleButton-root"
      sx={deepmerge(root, sx)}
      onClick={onClick}
      {...props}
    >
      <Icon sx={searchIcon} />
      <Typography sx={label}>{placeholder}</Typography>
    </ButtonBase>
  )
}
